module.exports = __webpack_public_path__ + "static/media/list.e17ccecd.svg";